/**
 * Whether Manage Invites should offer Revoke (#3561 round 2, Frank F1).
 * Pure, so web and native (`@shared/lib/inviteRevocable`) share it without
 * pulling the API transport into native tests.
 *
 * This is the HINT for the backend gate `isRevocableInvite` in
 * backend/src/routes/invites.ts; the two must agree (Core Rule 48). Pending
 * invites are revocable, and so are MULTI-USE links already marked
 * 'accepted': email sign-up marks them so after the first join, yet they keep
 * admitting people. A spent single-use invite is not revocable.
 */
export function isRevocableInvite(invite: { status: string; max_uses: number | null }): boolean {
  if (invite.status === 'pending') return true;
  const isMultiUse = invite.max_uses === null || invite.max_uses > 1;
  return isMultiUse && invite.status === 'accepted';
}
